export default "/bundles/assets/offline_4b2ea1e4d5e1f47f10b0a6a41d30815d.png";